import React, { Component } from 'react'
import ButtonDefault from 'components/Buttons/Default'
import close from 'assets/images/ico/close.svg'

class Overlay extends Component {
  state = {
    active: false,
    params: this.props,
    payload: null,
    mobile: null,
  }

  componentDidMount() {
    this.$app.event.$on(
      `overlay.activity.${this.props.type}`,
      ({ status, payload, ...rest }) => {
        this.setState({ active: status, payload, ...rest })
      },
    )
  }

  close = () => {
    this.setState({ active: false })
    this.$app.auth.setHideOnboarding(false)
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        params: this.state.params,
        payload: this.state.payload,
        mobile: this.state.mobile,
      }),
    )

    return (
      <div className={`overlay ${this.state.active && 'active'}`}>
        {this.state.active && (
          <>
            {this.props.showCloseIcon && (
              <ButtonDefault
                customClass="overlay-close"
                type="circle"
                bgColor="white"
                size="medium"
                onClick={this.close}
                icon={<img src={close} className="icon white" alt="close" />}
              />
            )}
            <div className="overlay-content">
              {this.state.active && childrenWithProps}
            </div>
          </>
        )}
      </div>
    )
  }
}

Overlay.defaultProps = {
  showCloseIcon: true,
}

export default Overlay
